<div
	class="
		skeleton-product-card-container
		hmf-display-flex
		hmf-flex-column
		hmf-position-relative
		hmf-pt-s"
	[class]="isCompact() ? 'compact' : 'full-size'"
>
	<div class="
			image-and-details-wrapper
			hmf-display-flex
			hmf-flex-column"
		>

		<div class="product-image-wrapper" [class]="isCompact() ? 'shrink' : 'expand'">
			<div class="product-image skeleton-grey-loading-animation" ></div>
		</div>

		<div class="details-wrapper hmf-display-flex hmf-flex-column">
			<div class="product-name-section">
				<div class="product-name-placeholder skeleton-grey-loading-animation"></div>
			</div>
			<div class="price-section">
				<div class="price-placeholder skeleton-grey-loading-animation"></div>
			</div>
			<div class="hmf-display-flex hmf-pt-xxs">
				@for (star of [0,0,0,0,0]; track trackbyFn($index)) {
					<homefield-icon
						width="16px"
						height="16px"
						name="star-filled-0-percent"
					>
					</homefield-icon>
				}
			</div>
		</div>
	</div>

	<button hmf-button
		class="select-options-button hmf-mb-xxs hmf-mb-sm-s"
		[size]="'small'"
		disabled="true"
		>
		Select Options
	</button>

	<button hmf-button
		class="product-remove-button hmf-position-absolute hmf-p-s"
		aria-hidden="true"
		tabindex="-1"
		disabled="true"
	>
		<homefield-icon
			name="delete-filled"
			width="16px"
			height="16px"
		></homefield-icon>
	</button>
</div>
